<template>

<div class="xgroup" >
    <el-link :underline="false" v-if="viewSetting"  v-popover:popover @click="viewsVisiable = !viewsVisiable"
        style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);border-radius: 4px;background-color: rgb(43 146 246); padding: 7px 15px;"
    >
        <div class="wrap" v-show="true">
            <span style="color:white">
                <span>{{msg("当前视图")+'：'}}</span>
                <span style="font-size:15px;font-weight:600;">{{viewSetting.name}}</span>
                <i class="el-icon-caret-bottom" ></i>
            </span>
        </div>
    </el-link>
    <el-popover
        ref="popover"
        width="300"
        placement="bottom"
        v-model="viewsVisiable"
        trigger="hover">
        <div class="views">
            <el-input :placeholder="msg('搜索视图')" v-model="viewFilterText" size="mini" clearable>    
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-scrollbar style="height:300px;">
                <div class="view-group" v-for="(value, key) in views" :key="key">
                    <h5>{{key}}</h5>
                    <span v-for="view in value" :key="view.id" >
                        <el-link v-show="view.show"
                            style="display:block; padding: 5px 15px;"
                            :underline="false" 
                            :type="(viewSetting && viewSetting.id === view.id)?'primary':'default'"
                            @click="changeViews(view)">{{view.name}}
                        </el-link>
                    </span>
                </div>
                <el-button style="margin-top:10px; margin-bottom:10px; text-align:center;" 
                    v-show="loadMored" plain size="mini" 
                    @click="getAllViews(1)">{{msg('加载更多')}}</el-button>
            </el-scrollbar>
            
        </div>
    </el-popover>
</div>
</template>
<script>
export default {
    name: "ViewSelector",
    data(){
        return {
            viewsVisiable: null,
            viewSetting: null,
            viewFilterText: null,
            views:null,
            loadMored:true
        }
    },
    watch: {
        viewFilterText: {
            immediate: true,
            handler(){
                if(!this.views) return;
                const kw = (this.viewFilterText || "").trim().toLowerCase();
                Object.keys(this.views).forEach(group => {
                    const list = this.views[group] || [];
                    list.forEach(v => {
                        v.show = !kw || (v.name || "").toLowerCase().indexOf(kw) >= 0;
                    });
                });
            }
        }
    },
    props:{
        type: Number,  //0-用户视图，1-货运视图，2-库存视图
    },
    mounted: function(){
        this.getAllViews(0);
    },
    methods: {
        getDefaultView(cb, id){
            let url = null;
            if(id){
                url = this.$kit.api.viewSetting.get+"?id="+id;
            }else{
                url = this.$kit.api.viewSetting.defaultView+"?t="+this.type;
            }

            this.$axios.get(url)
            .then((result) => {
                if(result.status){
                    this.viewSetting = result.data;
                    if(cb){
                        cb(result.data);
                    }
                }
            });
        },
        getAllViews(type){
            
            //type==0, 加载常用视图
            //type==1, 加载系统视图，自定义视图
            if(!this.views) {
                this.views = {};
            }

            this.$axios.post(this.$kit.api.viewSetting.listByType+"?type="+(type||0), 
                {category: this.type}
            ).then((result) => {
                if(result.status){
                    
                    let views1 = this.views["常用视图"] || [];
                    let views2 = this.views["系统视图"] || [];
                    let views3 = this.views["自定义视图"] || [];

                    for(let i=0; i<result.data.length; i++){
                        let v = result.data[i];
                        v['show'] = true;
                        if(type==1){
                            if(v.creater == 0){
                                views2.push(v);
                            }else{
                                views3.push(v);
                            }
                        }else{
                            views1.push(v);
                        }

                    }

                    if(views1.length>0){
                        this.views["常用视图"] = views1;
                    }
                    if(views2.length>0){
                        this.views["系统视图"] = views2;
                    }
                    if(views3.length>0){
                        this.views["自定义视图"] = views3;
                    }

                    if(type == 1){
                        this.loadMored = false;
                    }

                    this.$nextTick(() => {
                        const kw = (this.viewFilterText || "").trim().toLowerCase();
                        Object.keys(this.views || {}).forEach(group => {
                            const list = this.views[group] || [];
                            list.forEach(v => {
                                v.show = !kw || (v.name || "").toLowerCase().indexOf(kw) >= 0;
                            });
                        });
                    });

                }
            });
        },
        changeViews(view){
            // this.viewSetting = view;
            // if(view.queries){
            //     this.query.queries = view.queries;
            //     this.buildQueries();
            // }
            this.viewSetting = view;

            if(!view.queries || view.queries.length == 0 || !view.details){
                this.$axios.get(this.$kit.api.viewSetting.get+"?id="+view.id)
                    .then((result) => {
                        if(result.status){
                            this.viewSetting["details"] = result.data.details;
                            this.viewSetting["queries"] = result.data.queries;
                            this.viewSetting["btns"] = result.data.btns;
                            this.$emit("change", this.viewSetting);
                        }
                });
            }else{
                this.$emit("change", this.viewSetting);
            }

            this.viewsVisiable = false;
        },
    }
}
</script>